class OffCanvasMenu extends HTMLElement {
    constructor() {
      super();
      this.classNames = {
        menuParent: 'offcanvas-canvas',
        menuLeft: 'offcanvas--left',
        menuPush: 'offcanvas--push',
        menuFilter: 'offcanvas--filter',
        isOpen: 'is-offcanvas-open',
        isPush: 'is-offcanvas-push',
        isFilter: 'is-offcanvas-filter',
        isPushLeft: 'is-offcanvas-push-left',
        smoothScroll: 'scroll-behavior-smooth'
      };


      // move menu into the root parent element (where it needs to be for "push"
      // effect) if not already there this allows menus to be included outside
      // theme.liquid and use section data as needed
      const menuParentEl = document.querySelector(`.${this.classNames.menuParent}`);
      if (menuParentEl && this.parentElement.classList[0] !== menuParentEl.classList[0]) {
        menuParentEl.appendChild(this);
      }

      this.hidden = true;
      this.addDimmer();
      this.initControls();
      this.smoothScroll = document.documentElement.classList.contains(
        this.classNames.smoothScroll
      );
    }

    initControls() {
      this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());

      this.closeButtons = this.querySelectorAll('button[name="close"]');
      this.closeButtons.forEach(b =>
        b.addEventListener('click', this.close.bind(this))
      );

      this.toggleButtons = document.querySelectorAll(`a[href="#${this.id}"], [data-menu-toggle="${this.id}"]`);
      this.toggleButtons.forEach(t => {
        t.addEventListener('click', (e) => {
          e.preventDefault();
          this.toggle();
        });
      });
    }

    toggleSmoothScroll() {
      if (this.smoothScroll) {
        document.documentElement.classList.toggle(
          this.classNames.smoothScroll
        );
      }
    }

    open(addedToCart) {
      const openClasses = [this.classNames.isOpen];

      if (!this.hidden) {
        return;
      }

      const miniCart = document.getElementById('mini-cart');
      if (this.id == 'mini-cart' && addedToCart) {
        miniCart.classList.add('just-added');
      }


      window.theme?.noscroll?.apply();

      this.toggleSmoothScroll();

      if (this.classList.contains(this.classNames.menuPush)) {
        openClasses.push(this.classNames.isPush);
        if (this.classList.contains(this.classNames.menuFilter)) {
          openClasses.push(this.classNames.isFilter);
        }
        if (this.classList.contains(this.classNames.menuLeft)) {
          openClasses.push(this.classNames.isPushLeft);
        }
      }

      this.addEventListener('transitionend', () => {
        this.focus();
        trapFocus(this);
      }, { once: true });

      this.dimmer.hidden = false;
      this.hidden = false;

      window.requestAnimationFrame(() => {
        this.classList.add('is-active');
        document.body.classList.add(...openClasses);
      });

      if (this.id == 'mini-cart' && addedToCart) {
        setTimeout(() => {
          miniCart.classList.remove('just-added');
        }, 2000);

        document.querySelector('.cart__items > div')?.scrollIntoViewIfNeeded();
        document.body.classList.add('mini-cart-open');
        document.body.classList.remove('quickbuy-open');
      }
    }

    close() {
      if (this.hidden) {
        return;
      }

      window.theme?.noscroll?.remove();
      this.toggleSmoothScroll();

      document.body.classList.remove(
        this.classNames.isOpen,
        this.classNames.isPush,
        this.classNames.isPushLeft,
        this.classNames.isFilter
      );

      this.addEventListener('transitionend', () => {
        this.hidden = true;
        this.dimmer.hidden = true;
        removeTrapFocus(this.activeElement);
      }, { once: true });
      this.classList.remove('is-active');
      document.querySelector('body').classList.remove('mini-cart-open');
      document.querySelector('.mini-cart-add-error').classList.add('hidden');
    }

    toggle() {
      if (!document.querySelector('body').classList.contains('mini-cart-open')) {
        if (this.hidden) {
          this.closeAllMenus();
          this.open();
        } else {
          this.close();
        }
      }
    }

    addDimmer() {

      this.dimmer = document.querySelector('.offcanvas-dimmer');
      if (this.dimmer) {
        return;
      }
      this.dimmer = document.createElement('div');
      this.dimmer.classList.add('offcanvas-dimmer');

      document.querySelector('body').appendChild(this.dimmer);
      this.dimmer.addEventListener('click', this.closeAllMenus);
    }

    closeAllMenus() {
      document.querySelectorAll('offcanvas-menu').forEach(menu => {
        menu.close();
      });

      if (document.querySelector('body').classList.contains('quickbuy-open')) {
        document.querySelector("mobile-variant-selector").closeSizes()
      }
    }
  }

  customElements.define('offcanvas-menu', OffCanvasMenu);
